import { useAppSelector } from '@store';
import SetupTwoFactorForm from '../../components/setup-two-factor/setup-two-factor';

const SetupTwoFactor = () => {
  const { totpUri } = useAppSelector((state) => state.auth);

  return <SetupTwoFactorForm totpUri={totpUri} />;
};

export default SetupTwoFactor;
